import { render, staticRenderFns } from "./BeefreeEmailEditor.vue?vue&type=template&id=7c2b4984&scoped=true&"
import script from "./BeefreeEmailEditor.vue?vue&type=script&lang=js&"
export * from "./BeefreeEmailEditor.vue?vue&type=script&lang=js&"
import style0 from "./BeefreeEmailEditor.vue?vue&type=style&index=0&id=7c2b4984&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2b4984",
  null
  
)

export default component.exports